import { useLocation } from 'react-router-dom'
import { getLang } from '@/lib/lang'
/** Source: public/design-patterns.html C-8a; fixed copy: docs/structure/03_詳細設計_文章正典と導線.md A-4. */
import notesJson from '../../content/notes.json'
import notesEnJson from '../../content/notes.en.json'
type Box = { heading: string; items: string[] }
const notesJa = notesJson as Record<string, Box>
const notesEn = notesEnJson as Record<string, Box>
export function Caution({ noteId, boxes = [] }: { noteId?: string | string[]; boxes?: Box[] }) {
  // 定型注記(notes.json)は EN ページでは notes.en.json(同 id)を使う
  const notes = getLang(useLocation().pathname) === 'en' ? notesEn : notesJa
  const ids = typeof noteId === 'string' ? [noteId] : noteId ?? []
  const selected = [...ids.map((id) => notes[id]).filter((box): box is Box => Boolean(box)), ...boxes]
  return <div className="shell sec tight" style={{ display: 'grid', gap: 16 }}>{selected.map((box, i) => <div className="caution" key={`${box.heading}-${i}`}><h4>{box.heading}</h4><ul>{box.items.map((item) => <li key={item}>{item}</li>)}</ul></div>)}</div>
}
